/* eslint-disable no-useless-escape */
const RegexExpression = {
  NUMERAL: /%?\d+(?:[.,]\d*)*%?/gi,
  METRIC: /c|a|f/gi,
  DATE: /\d{2,4}[-\/]\d{2,4}[-\/]\d{2,4}/,
  FLOAT: /^[+-]?\d+(\.\d+)?$/,
  WHOLE_WORD: /[a-zA-Z0-9]+[a-zA-Z_][a-zA-Z0-9]+(?!\w*\()/gm,
  WHOLE_WORD_GENERIC_FORM: /[a-zA-Z0-9]+[a-zA-Z][a-zA-Z0-9]+/gm,
  WHOLE_WORD_FILTERS: /[a-zA-Z0-9]+[a-zA-Z][a-zA-Z0-9_.]+/gm,
  UNQUOTED_WHOLE_WORD: /[a-zA-Z0-9]+\.{0,1}[a-zA-Z_][a-zA-Z0-9]+(?!\w*\()+(?!['"]*[a-zA-Z0-9]*['"])/gm,
  NOT_WHOLE_WORD: /(?![a-zA-Z0-9]+)/gm,
  PIX_MATH_UTILS: /[a-zA-Z0-9]+[a-zA-Z_][a-zA-Z0-9]+\(.*?\)/gm,
  INCOME_EXPENSES_TABLE: /comp\d/gm,
  // VARIABLE: /\$([a-zA-Z])+/gm, // $variable
  FUNCTION_EXPRESSION: /[a-zA-Z_]+\(.*\)/gm, // Matches with a function expression -> "trunc(23) {}" will result in "trunc(23)"
  FUNCTION_NAME: /([a-zA-Z_{1}][a-zA-Z0-9_]+)(?=\()/gm, // Matches with the name of a given function -> trunc(23.344) will result to "trunc"
  FUNCTION_ARGUMENTS: /(?<=\()(.*?)(?=\))/gm, // Matches with the arguments of a given function -> trunc(23.344) will result to "23.344",
  EVAL_UNQUOTED_WHOLE_WORD: /[a-zA-Z]+\.{0,1}[a-zA-Z]+(?!['"]*[a-zA-Z]*['"(])/gm, // Matches all those words that are not between quotes => "ParentInfo.RentableArea * NumberOfFloors = 'SomeStringValue'" will result to [ParentInfo.RentableArea, NumberOfFloors]
  INSTANCE: /INSTANCE_.{2,6}/,
};

const handlerWithNewRegex = {
  get(target, prop) {
    return new RegExp(target[prop]);
  },
};

const Regex = new Proxy(RegexExpression, handlerWithNewRegex);

export default Regex;
